import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillHistoryData = function backfillHistoryData(_this) {
  var zdInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  _this.oppBusiData.CSDC_INFO = _.cloneDeepGet(_this.historyData, "DETAIL_DATA.CSDC_INFO", {});
  if (!_.isEmpty(zdInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], zdInfo);
  }
};

var QUERY_ACCT_TYPE = [{
  DICT_ITEM: "08",
  DICT_ITEM_NAME: "一码通"
}, {
  DICT_ITEM: "11",
  DICT_ITEM_NAME: "沪市A股账户"
}, {
  DICT_ITEM: "21",
  DICT_ITEM_NAME: "深市A股账户"
}];

var initFieldConfig = function initFieldConfig(_this) {
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_TITLE = "中登账户信息查询";
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _.set(fields, "YMT_TRDACCT_TYPE.FIELD_DICT_NAME", QUERY_ACCT_TYPE);
  _.set(fields, "YMT_TRDACCT_CODE.VALID_TYPE", "on-blur");

  _this.$storage.removeSession("ZDInfo");
  if (_this.oppBusiData.hasAppvTask1) {
    fields.YMT_TRDACCT_TYPE.FIELD_CONTROL = "2";
    fields.YMT_TRDACCT_CODE.FIELD_CONTROL = "2";
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var zdInfo, oldZdInfo, YMT_TRDACCT_TYPE, YMT_CODE, OTHER_CODE;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              zdInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);
              oldZdInfo = _.get(params, "" + SAVE_PATH);
              ;
              YMT_TRDACCT_TYPE = zdInfo.YMT_TRDACCT_TYPE;
              YMT_CODE = void 0;
              OTHER_CODE = void 0;

              if (YMT_CODE == "08") {
                YMT_CODE = zdInfo.YMT_TRDACCT_CODE;
              } else {
                OTHER_CODE = zdInfo.YMT_TRDACCT_CODE;
              }

              if (!params.DETAIL_DATA) {
                params.DETAIL_DATA = {};
              }

              params.DETAIL_DATA.CSDC_INFO = _this.oppBusiData.CSDC_INFO;

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], zdInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldZdInfo, zdInfo));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  CHECK_YMT_TRDACCT_CODE: function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this, field, fieldData) {
      var data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (field.DEFAULT_VALUE) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              if (fieldData.YMT_TRDACCT_TYPE.DEFAULT_VALUE) {
                _context3.next = 5;
                break;
              }

              _this.alert("请先选择证券类型");
              return _context3.abrupt("return", new _Promise(function (resolve, reject) {
                _this.alert("请先选择证券类型");
                resolve(false);
              }).then(function (res) {
                return res;
              }));

            case 5:
              data = {
                code: field.DEFAULT_VALUE,
                ACCT_TYPE: fieldData.YMT_TRDACCT_TYPE.DEFAULT_VALUE,
                F_CUST_ORG_CODE: _this.$storage.getSession(_this.$definecfg.F_CUST_ORG_CODE)
              };

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在查询中登数据...");

              _this.$syscfg.K_Request("F0000052", data, true, true).then(function (res) {
                if (res.Code == "0") {
                  _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                  if (res.Data && res.Data.length > 0) {
                    _this.oppBusiData.CSDC_INFO = res.Data[0];
                    _this.$blMethod.backFillCsdcInfo(_this, _this.oppBusiData.CSDC_INFO);
                    if (_this.userType == "2") {
                      var zdModule = _this.groupDatas.OCR_ORG_INFO_PAGE.ZD_MODULE[0].FIELDS;
                      if (_this.oppBusiData.CSDC_INFO.ID_CODE && (zdModule.ID_CODE.DATASOURCE == "1" || !zdModule.ID_CODE.DEFAULT_VALUE)) {
                        zdModule.NEW_ID_CODE.DEFAULT_VALUE = _this.oppBusiData.CSDC_INFO.ID_CODE;
                      }
                    }
                  }
                } else {
                  _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                  var msg = res.Msg;
                  msg = msg.substring(msg.lastIndexOf(":") + 2, msg.length - 2);
                  alert(msg);
                }
              }).catch(function (err) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                consoleLog("查询中登信息失败", err.toString());
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function CHECK_YMT_TRDACCT_CODE(_x5, _x6, _x7) {
      return _ref3.apply(this, arguments);
    }

    return CHECK_YMT_TRDACCT_CODE;
  }(),
  CHECK_YMT_TRDACCT_TYPE: function CHECK_YMT_TRDACCT_TYPE(_this, field, fieldData) {
    fieldData.YMT_TRDACCT_CODE.DEFAULT_VALUE = "";
    _.set(fieldData, "YMT_TRDACCT_CODE.FIELD_TITLE", "一码通账户");
    if (field.DEFAULT_VALUE == "11" || field.DEFAULT_VALUE == "21") {
      _.set(fieldData, "YMT_TRDACCT_CODE.FIELD_TITLE", "证券账户");
    }
  },
  update: update
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizZdInfo/bizZdInfoNode.js
// module id = 152
// module chunks = 2